import { createContext, useContext } from 'react'

export const AccountClientsTableContext = createContext({})

export const useAccountClientsActions = () => {
  return useContext(AccountClientsTableContext)
}
